import { reducer as form } from 'redux-form';
import { persistReducer } from 'redux-persist'
import { combineReducers } from 'redux'
import storage from 'redux-persist/lib/storage'
import { reducer as pageInfo } from '../common/pageInfo';
import { reducer as bookmakersSwitcher } from '../bookmakersSwitcher';
import { reducer as loginPage } from '../common/loginPage';
import { reducer as bookmakersList } from '../common/bookmakersList';
import { reducer as bookmakersInfo } from '../common/bookmakersInfo';
import { reducer as drawerInfo } from '../drawer';
import { reducer as bet } from '../common/bet';
import { reducer as freeBets } from '../common/freeBets';
import { reducer as modals } from '../modals';
import { reducer as topUp } from '../common/topUp';
import { reducer as externalAccount } from '../common/externalAccount';
import { reducer as gdpr } from '../common/gdpr';
import { reducer as bookmakersListPopover } from '../common/bookmakersListPopover';

import {
    initialState as initialBookmakersInfoState,
} from '../common/bookmakersInfo/bookmakersInfo.reducer'
import {
    initialState as initialDrawerInfoState,
} from '../drawer/drawer.reducer'

// The persistence version should be bumped (major) whenever we change store data in
// a major way. We can then define migrations to avoid bugs.
// @see README.md
// @see https://github.com/rt2zz/redux-persist/blob/master/docs/migrations.md
//
// IMPORTANT - `version` can only be an integer
// i.e. every version is treated as a major version
const persistConfig = {
    key: 'betslip',
    storage,
    version: 15,
    whitelist: [
        'bookmakersInfo',
        'drawerInfo',
    ],
    migrate: (oldState, version) => {
        if (!oldState) {
            return Promise.resolve({})
        }

        // eslint-disable-next-line no-underscore-dangle
        if (oldState._persist && oldState._persist.version === version) {
            return Promise.resolve(oldState)
        }

        return Promise.resolve({
            ...oldState,
            bookmakersInfo: initialBookmakersInfoState,
            drawerInfo: initialDrawerInfoState,
        })
    },
}
const rootReducer = combineReducers({
    form,
    modals,
    pageInfo,
    bookmakersInfo,
    bookmakersList,
    bookmakersSwitcher,
    loginPage,
    drawerInfo,
    bet,
    freeBets,
    topUp,
    externalAccount,
    gdpr,
    bookmakersListPopover,
})
const persistedRootReducer = persistReducer(persistConfig, rootReducer)

export default persistedRootReducer



// WEBPACK FOOTER //
// /src/js/App/rootReducer.js